import { render, staticRenderFns } from "./branchAccept.vue?vue&type=template&id=5112a5a2"
import script from "./branchAccept.vue?vue&type=script&lang=js"
export * from "./branchAccept.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports